const ADDRESS_ICONS = {
  PIN: 'MarkerPin1Outlined',
  HOME: 'Home5Outlined',
  HEART: 'HeartOutlined',
  WORK: 'Briefcase1Outlined',
  FLAG: 'Flag1Outlined'
}

export default ADDRESS_ICONS
